






































































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { saveAs } from 'file-saver';
import dateFormat from 'dateformat';

import AdminPanel from '@/components/Panels/AdminPanel.vue';
import UploadTemplateControl from './support/UploadTemplateControl.vue';
import FilterBar from '@/components/Filters/FilterBar.vue';
import BaseTable from '@/components/Table/BaseTable.vue';
import ModalConfirm from '@/components/Form/ModalConfirm.vue';
import { IIndicatorValue } from '@/model/datamart';
import { IIndicator, ISensorDevice } from '@/model/meta';

export default Vue.extend({
    name: 'ExcelExport',
    metaInfo: {
        title: 'Экспорт значений',
    },
    components: {
        AdminPanel,
        UploadTemplateControl,
        FilterBar,
        BaseTable,
        ModalConfirm,
    },
    computed: {
        ...mapGetters('viewing', {
            preloader: 'getPreloader',
            failLoading: 'getFailLoading',
            activeFormRequest: 'getActiveFormRequest',
            failedFormRequest: 'getFailedFormRequest',
            gridData: 'getIndictorValuesGrids',
            devicesFilter: 'getActiveDevices',
            indicatorsFilter: 'getAbailableIndicators',
        }),
        ...mapGetters('auth', {
            getUserId: 'getUserId',
        }),
        gridDataCast(): { [key: string]: IIndicatorValue[] } {
            const dataArray = this.gridData as {
                [key: string]: IIndicatorValue[];
            };
            if (dataArray !== undefined && dataArray !== null) {
                return dataArray;
            }
            return {} as { [key: string]: IIndicatorValue[] };
        },
        filterSetting(): Array<any> {
            return [
                {
                    code: 'device',
                    filterType: 'search-select',
                    label: 'Устройство:',
                    dataSet: this.devicesFilter,
                    textField: 'name',
                    valueField: 'ALL_OBJECT',
                },
                {
                    code: 'indicators',
                    filterType: 'multi-select',
                    selectSize: 3,
                    label: 'Показатели:',
                    dataSet: this.indicatorsFilter,
                    masterValue: this.getDeviceFilterId(),
                    textField: 'name',
                    valueField: 'ALL_OBJECT',
                },
                {
                    code: 'period',
                    filterType: 'range-datetime',
                    label: 'Период:',
                },
            ];
        },
        tablesShow(): boolean {
            const exsists = Object.keys(this.gridDataCast).find(key => {
                return this.gridDataCast[key].length > 0;
            });
            return exsists !== undefined && exsists !== null;
        },
        showEmptyData(): boolean {
            return !this.tablesShow && !this.firstShow;
        },
    },
    methods: {
        ...mapActions('viewing', {
            resetForm: 'resetForm',
            loadDevices: 'loadActiveDevices',
            setIndicators: 'setAvailableIndicators',
            cleanIndicators: 'cleanAvailableIndicators',
            loadData: 'loadValuesGrids',
            resetGridsData: 'resetGridsData',
            getExcelExport: 'excelExport'
        }),
        inputHandler() {
            if (this.filters['device'] !== undefined) {
                this.setIndicators(this.filters['device']);
            }
            this.filterCompleted = this.getFilterCompleted();
        },
        refreshAction() {
            if (this.filterCompleted) {
                this.loadData({
                    device: this.filters['device'],
                    indicators: this.filters['indicators'],
                    begin: this.filters['period'][0],
                    end: this.filters['period'][1],
                }).then(() => {
                    // do something
                    this.firstShow = false;
                    // запомним для дальнейшей работы. Фильтры могут изменить значения
                    this.lastDevice = this.filters['device'] as ISensorDevice;
                    this.lastIndicatorsList = this.lastDevice.availableIndicators;
                    this.lastIndicators = this.filters['indicators'];
                    this.lastPeriodBegin = this.filters['period'][0] as Date;
                    this.lastPeriodEnd = this.filters['period'][1] as Date;
                });
            }
        },
        getDeviceFilterId(): string {
            if (
                this.filters['device'] !== undefined &&
                this.filters['device'] !== null
            ) {
                return this.filters['device']['sensorDeviceId'];
            }
            return '';
        },
        getTableTitle(key: string): string | undefined {
            const indicators = this.lastIndicatorsList as IIndicator[];
            if (indicators !== undefined) {
                const indicator = indicators.find(item => {
                    return item.indicatorId === key;
                });

                if (indicator !== undefined) return indicator.name;
            }

            return undefined;
        },
        getIndCodeById(key: string): string | undefined {
            const indicators = this.lastIndicatorsList as IIndicator[];
            if (indicators !== undefined) {
                const indicator = indicators.find(item => {
                    return item.indicatorId === key;
                });

                if (indicator !== undefined) return indicator.code;
            }
            return undefined;
        },
        getFilterCompleted(): boolean {
            return (
                this.filters['device'] !== undefined &&
                this.filters['device'] !== null &&
                this.filters['indicators'] !== undefined &&
                this.filters['indicators'] !== null &&
                this.filters['indicators'].length > 0 &&
                this.filters['period'] !== undefined &&
                this.filters['period'] !== null &&
                this.filters['period'].length > 1
            );
        },
        excelExport() {
            this.excelShow = true;
        },
        closeExcel(): void {
            this.excelShow = false;
        },
        async excelExportAction(): Promise<void> {
            try {
                // получим файл от сервера
                const templateBlob = (await this.getExcelExport({
                    device: this.lastDevice,
                    indicators: this.lastIndicators,
                    begin: this.lastPeriodBegin,
                    end: this.lastPeriodEnd
                })) as Blob;
                // составим имя
                const fileNameTemp = `excelExportTemp_${dateFormat(new Date(), 'yyyymmdd_HHMMss')}.xlsx`;
                // сохраним
                saveAs(templateBlob, fileNameTemp);
            } catch (e) {
                console.error('export error');
            }
            this.excelShow = false;
        },
    },
    mounted() {
        this.loadDevices(this.getUserId);
        this.resetGridsData();
    },
    data() {
        return {
            filters: {} as any,
            firstShow: true as boolean,
            filterCompleted: false as boolean,
            excelShow: false as boolean,
            lastDevice: undefined as ISensorDevice | undefined,
            lastIndicatorsList: [] as IIndicator[] | undefined,
            lastIndicators: [] as IIndicator[] | undefined,
            lastPeriodBegin: undefined as Date | undefined,
            lastPeriodEnd: undefined as Date | undefined,
            fields: [
                {
                    key: 'timestamp',
                    label: 'Время',
                    sortable: true,
                    isDatetime: true
                },
                { key: 'value', label: 'Значение', sortable: true },
                /**{
                    key: 'textValue',
                    label: 'Строковое значение',
                    sortable: true
                }*/
            ],
        };
    }
});
